"use client";

// Thème : clair, sombre ou auto (suit le système). Le choix vit dans localStorage ; le thème résolu (clair ou sombre)
// est posé en data-theme sur <html>, d'abord par le script du layout (avant le premier rendu, sans flash), puis ici.

import { useSyncExternalStore } from "react";

export type Choix = "light" | "dark" | "auto";
export type Theme = "light" | "dark";

const CLE = "theme";
const ecouteurs = new Set<() => void>();
const systeme = () => window.matchMedia("(prefers-color-scheme: dark)");

export function choixCourant(): Choix {
  const v = localStorage.getItem(CLE);
  return v === "light" || v === "dark" ? v : "auto";
}

function resoudre(choix: Choix): Theme {
  return choix === "auto" ? (systeme().matches ? "dark" : "light") : choix;
}

function appliquer() {
  document.documentElement.dataset.theme = resoudre(choixCourant());
  ecouteurs.forEach((f) => f());
}

export function choisir(choix: Choix) {
  if (choix === "auto") localStorage.removeItem(CLE);
  else localStorage.setItem(CLE, choix);
  appliquer();
}

function abonner(f: () => void) {
  ecouteurs.add(f);
  const mq = systeme();
  mq.addEventListener("change", appliquer);
  window.addEventListener("storage", appliquer);
  return () => {
    ecouteurs.delete(f);
    mq.removeEventListener("change", appliquer);
    window.removeEventListener("storage", appliquer);
  };
}

export function useChoix(): Choix {
  return useSyncExternalStore(abonner, choixCourant, () => "auto");
}

export function useTheme(): Theme {
  return useSyncExternalStore(
    abonner,
    () => resoudre(choixCourant()),
    () => "light",
  );
}
